export default "__VITE_ASSET__36e98603__"